import moment from "moment";
import React, { forwardRef, useState } from "react";
import ReactDatePicker from "react-datepicker";
import MultiSelect, { components } from "react-select";
import Rating from "react-rating";
import "react-datepicker/dist/react-datepicker.css";
import { SlCalender } from "react-icons/sl";
import {
  FaCalendarAlt,
  FaChevronDown,
  FaFileImage,
  FaFileUpload,
  FaRegStar,
  FaSearch,
  FaStar,
} from "react-icons/fa";
import { LogoImg2 } from "assets/images";

// export const Button = ({ type, className, isDisabled, children, ...rest }) => {
//   return (
//     <>
//       <button
//         type={type ? type : "button"}
//         disabled={isDisabled}
//         className={`button ${className}`}
//         {...rest}
//       >
//         {children}
//       </button>
//     </>
//   );
// };

export const Input = forwardRef(
  (
    {
      value = "",
      onChange,
      className = "",
      label,
      error,
      required,
      extraError = false,
      infoErr = false,
      optional = false,
      subText,
      maxLength = 5000,
      ...rest
    },
    ref
  ) => {
    const classGenerator = () => {
      if (infoErr && extraError) {
        return "is-invalid";
      }
      if (infoErr) {
        return "info";
      }
      return ((!value && error) || extraError) && "is-invalid";
    };
    return (
      <>
        {label && (
          <label className="label">
            {label}
            {required && <span className="required mx-1"> *</span>}
            {optional && <em className="optional">{"(optional)"}</em>}
            {subText && <span className="subText">{subText}</span>}
          </label>
        )}
        <input
          value={value}
          onChange={onChange}
          className={`form-control input ${className} ${classGenerator()}`}
          ref={ref}
          maxLength={maxLength}
          {...rest}
        />
        {error && (
          <span className={`${infoErr ? "info-feedback" : "invalid-feedback"}`}>
            {error}
          </span>
        )}
      </>
    );
  }
);

export const Select = ({
  label,
  onChange,
  value,
  error,
  extraErr = false,
  className,
  children,
  required,
  loading,
  ...rest
}) => {
  const classGenerator = () => {
    if (extraErr) {
      return "is-invalid";
    }
    if (error && !value) {
      return "is-invalid";
    }
  };
  return (
    <>
      {label && <label className="label">{label}</label>}
      <select
        onChange={onChange}
        value={value}
        className={`form-control input ${className} ${classGenerator()}`}
        {...rest}
        loading={loading ? "" : ""}
      >
        {children}
      </select>
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};

export const TextArea = ({
  value,
  onChange,
  label,
  className,
  error,
  required,
  loading,
  ...rest
}) => {
  return (
    <>
      <div>
        {label && <label className="label">{label}</label>}
        {required && <span className="text-danger"> *</span>}
      </div>
      <textarea
        value={value}
        onChange={onChange}
        className={`form-control input ${className} ${!value && error && "is-invalid"
          }`}
        {...rest}
        loading={loading ? "" : ""}
        style={{ resize: "none" }}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};

export const DatePicker = ({
  label,
  required,
  placeholder,
  error,
  className,
  name,
  selected,
  onChange,
  maxDate,
  minDate,
  ...rest
}) => {
  return (
    <>
      <div className="custom_date_picker">
        {label && <label className="label">{label}</label>}
        {required && <span className="text-danger"> *</span>}

        <ReactDatePicker
          placeholderText={placeholder}
          className={`form-control input date_picker ${className} ${!selected && error && "is-invalid"
            }`}
          name={name}
          showIcon
          // icon={<SlCalender className="calender_icon" />}
          // isClearable
          icon={<FaCalendarAlt />}
          showYearDropdown
          yearDropdownItemNumber={10}
          scrollableYearDropdown
          showMonthDropdown
          // useShortMonthInDropdown
          selected={selected ? new Date(selected) : null}
          onChangeRaw={(e) => e.preventDefault()}
          onChange={(date) =>
            onChange(date) ? (date) => onChange(date) : onChange
          }
          dateFormat="dd-MM-yyyy"
          maxDate={maxDate ? new Date(maxDate) : null}
          minDate={minDate ? new Date(minDate) : null}
          {...rest}
        />
        {error && (
          <p className={`invalid-feedback ${!selected && "d-block"}`}>
            {error}
          </p>
        )}
      </div>
    </>
  );
};

// const options = [
//   { value: 'apple', label: 'Apple' },
//   { value: 'banana', label: 'Banana' },
//   { value: 'orange', label: 'Orange' },
// ]

export const CommonSelect = ({
  label,
  onChange,
  value,
  error,
  className = "",
  options = [],
  isMulti = false,
  isSearchable = false,
  noOptionsMessage = () => "No options found",
  required = false,
  loading = false,
  isDisabled = false,
  placeholder = "Select",
  components: selectComponents = {},
  ...rest
}) => {
  const SearchDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <span className="react_select_indicator_icons">
        {isSearchable && <FaSearch size={13} />}
        <FaChevronDown size={12} />
      </span>
    </components.DropdownIndicator>
  );

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)"
        : "#fff", // Change background color of selected option
      color: state.isSelected
        ? "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)"
        : "black", // Change text color of selected option
      "&:hover": {
        backgroundColor: "linear-gradient(180deg, #01b4a7 0%, #00aace 100%)", // Change background color of option on hover
        color: "#222", // Change text color of option on hover
      },
    }),
    loadingIndicator: (base, state) => ({
      ...base,
      color: "#FF8989", // Set the color to red
    }),
  };

  const handleChange = (selectedOptions) => {
    onChange(selectedOptions);
  };
  return (
    <div className="custom_select">
      {label && <label className="label">{label}</label>}
      {required && <span className="text-danger"> *</span>}

      <MultiSelect
        onChange={handleChange}
        value={value}
        // className={`form-control input multi_select ${className} ${
        //   !value && error && "is-invalid"
        // }`}
        options={options}
        isMulti={isMulti}
        placeholder={placeholder}
        isSearchable={isSearchable}
        noOptionsMessage={noOptionsMessage}
        isLoading={loading}
        styles={customStyles}
        isDisabled={isDisabled}
        classNamePrefix="react_select"
        components={{
          DropdownIndicator: SearchDropdownIndicator,
          ...selectComponents,
        }}
        {...rest}
      />
      {/* {leftIcon} */}
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

// mui checkbox

// function CheckboxGroup({
//   name = '',
//   label = '',
//   checked,
//   onChange,
//   className = '',
//   value,
// }) {
//   return (
//     <FormControl component="fieldset" variant="standard">
//       <FormGroup>
//         <FormControlLabel
//           control={
//             <Checkbox
//               className={className}
//               checked={checked}
//               onChange={onChange}
//               value={value}
//               name={name}
//               sx={{
//                 color: '#FF8989',
//                 '&.Mui-checked': {
//                   color: '#FF8989',
//                 },
//               }}
//             />
//           }
//           label={label}
//         />
//       </FormGroup>
//     </FormControl>
//   )
// }

// export default CheckboxGroup

// export const dateFormat = (date) => {
//   return date ? moment(date).format('DD-MM-yyyy') : '---'
// }

export const dateMonthFormat = (date) => {
  return date ? moment(date).format("DD MMM yyyy") : "---";
};
export const timeFormat = (time) => {
  return time ? moment(time, "HH:mm").format("h:mm A") : "---";
};
export const searchDateFormat = (date) => {
  // return date ? moment(date).format("DD-MM-yyyy") : ""

  return date ? moment(date).format("yyyy-MM-DD") : "";
};

export const FileUpload = () => {
  return (
    <>
      <div className="simple_file_upload">
        <input type="file" id="fileUpload" />
        <label htmlFor="fileUpload">
          <b>Choose file</b>
          <span>Logo-file-name.png</span>
        </label>
        {/* <img src={LogoImg2} alt="" /> */}
      </div>
    </>
  );
};

export const ImageUpload = () => {
  const [imagePreview, setImagePreview] = useState(false);
  return (
    <>
      <div className="image_upload_wrap">
        <input type="file" id="imageUploader" />
        <label htmlFor="imageUploader">
          {imagePreview ? (
            <>
              {/* <FaFileUpload /> */}
              <p>Upload your file, click to browse</p>
            </>
          ) : (
            <>
              <div className="image_Preview">
                <img src={LogoImg2} alt="" />
              </div>
            </>
          )}
        </label>
      </div>
    </>
  );
};

export const RatingStar = ({
  user = null,
  rating,
  readonly = false,
  ratingValue = 1,
  onChange,
  increment = 0.1,
  ...rest
}) => {
  // Calculate total steps based on the desired increment
  const scaleFactor = 10 / increment; // Scaling factor to handle fractional values
  const normalizedRating = Math.round(ratingValue * scaleFactor); // Normalize rating (e.g., 3.7 -> 37 for 0.1 increment)

  const handleChange = (value) => {
    const newValue = value / scaleFactor; // Convert back to the desired increment value
    if (onChange) {
      onChange(newValue); // Update the rating
    }
  };

  return (
    <>
      <div className="rating">
        {/* <span className="_rating">{rating}</span> */}
        <Rating
          stop={rating}
          readonly={readonly}
          className="rating_star"
          initialRating={normalizedRating / scaleFactor}
          emptySymbol={<FaRegStar />}
          fullSymbol={<FaStar />}
          fractions={10}
          onChange={readonly ? undefined : handleChange}
          {...rest}
        />
        {user && <span className="user">{user}</span>}
      </div>
    </>
  );
};

export const LoadingButton = ({
  children,
  loading,
  className = "",
  ...rest
}) => {
  return (
    <button className={`button has_loader ${className}`} {...rest}>
      {loading ? (
        <>
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="24px"
            height="30px"
            viewBox="0 0 24 30"
            // style="enable-background:new 0 0 50 50;"
            className="loading_icon"
          >
            <rect x="0" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
            <rect x="10" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0.15s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0.15s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
            <rect x="20" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0.3s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0.3s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
          </svg>
        </>
      ) : (
        children
      )}
    </button>
  );
};
